function RegistrationRejected(){
    return(
        <div className={"mt-5 card justify-contents-center text-center"}>
            <h3 className={"card-title"}>Registration Rejected!</h3>
            <div className={"card-body"}>The business team has rejected your registration. Please contact support for further inquires!<div><button className={"btn btn-primary mt-2"} onClick={()=>{window.location.href="/"}}>Ok</button></div></div>
        </div>
    )
}
export default RegistrationRejected;
